module.exports = __webpack_public_path__ + "assets/images/green-xmas-scrollyimage1-desktop.jpg?v=3c4752ae";